<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-divider">健康管理</a>
              <small class="bc-divider"> > </small>
              <a class="bc-divider" href="#/overview">接种概况</a>
              <small class="bc-divider"> > </small>
              <a class="bc-active">已接种</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h5 id="title">接种图表</h5>
          <div id="infos">
            <p>姓名：{{ this.data.name }}</p>
            <p>性别：{{ this.data.gender }}</p>
            <p>出生日期：{{ this.data.birthday }}</p>
            <p>过敏源：{{ this.data.allergen }}</p>
            <div id="circle">
              <div class="y1">
                <div class="area">
                  <div class="area-item area-4">
                    <div
                        class="part"
                        style="background-color: mediumpurple; transform: rotate(0)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第三针">
                    </div>
                  </div>
                  <div class="area-item area-1">
                    <div
                        class="part"
                        style="background-color: hotpink; transform: rotate(0)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第一针">
                    </div>
                  </div>
                </div>
                <div class="area">
                  <div class="area-item area-3">
                    <div
                        class="part"
                        style="background-color: mediumpurple; transform: rotate(75deg)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第三针">
                    </div>
                    <div
                        class="part"
                        style="background-color: orange; transform: rotate(-15deg)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第二针">
                    </div>
                  </div>
                  <div class="area-item area-2">
                    <div
                        class="part"
                        style="background-color: hotpink; transform: rotate(-60deg)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第一针">
                    </div>
                    <div
                        class="part"
                        style="background-color: orange; transform: rotate(30deg)"
                        v-b-tooltip.hover title="21岁 hpv疫苗第二针">
                    </div>
                  </div>
                </div>
              </div>
              <div class="y2">
                <div class="area">
                  <div class="area-item area-4">
                    <div
                        class="part"
                        style="background-color: steelblue; transform: rotate(0)"
                        v-b-tooltip.hover title="19岁 狂犬疫苗第五针">
                    </div>
                  </div>
                  <div class="area-item area-1">
                    <div
                        class="part"
                        style="background-color: lightskyblue; transform: rotate(0)"
                        v-b-tooltip.hover title="19岁 狂犬疫苗第二针">
                    </div>
                  </div>
                </div>
                <div class="area">
                  <div class="area-item area-3">
                    <div
                        class="part"
                        style="background-color: yellow; transform: rotate(0)"
                        v-b-tooltip.hover title="19岁 狂犬疫苗第四针">
                    </div>
                  </div>
                  <div class="area-item area-2">
                    <div
                        class="part"
                        style="background-color: lightsteelblue; transform: rotate(0)"
                        v-b-tooltip.hover title="19岁 狂犬疫苗第三针">
                    </div>
                  </div>
                </div>
              </div>
              <div class="y3">
                <div class="area">
                  <div class="area-item area-4">
                    <div
                        class="part"
                        style="background-color: lightsalmon; transform: rotate(0)"
                        v-b-tooltip.hover title="18岁 狂犬疫苗第一针">
                    </div>
                  </div>
                  <div class="area-item area-1">
                    <div
                        class="part"
                        style="background-color: lightsalmon; transform: rotate(0)"
                        v-b-tooltip.hover title="18岁 狂犬疫苗第一针">
                    </div>
                  </div>
                </div>
                <div class="area">
                  <div class="area-item area-3">
                    <div
                        class="part"
                        style="background-color: lightsalmon; transform: rotate(0)"
                        v-b-tooltip.hover title="18岁 狂犬疫苗第一针">
                    </div>
                  </div>
                  <div class="area-item area-2">
                    <div
                        class="part"
                        style="background-color: lightsalmon; transform: rotate(0)"
                        v-b-tooltip.hover title="18岁 狂犬疫苗第一针">
                    </div>
                  </div>
                </div>
              </div>
              <div class="yc">18-30岁</div>
            </div>
            <div id="times">
              <a>0-3岁</a>
              |
              <a>3-6岁</a>
              |
              <a>6-12岁</a>
              |
              <a>12-18岁</a>
              |
              <a style="color: royalblue">18-30岁</a>
              |
              <a>40岁以上</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "CompleteGraph",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      items: [],
      data: {
        pid: 0,
        name: "",
        birthday: "",
        gender: "",
        allergen: "",
        medical_history: "",
        province: "",
        city: "",
        district: "",
        contact: "",
        contact_phone: "",
        phone: "",
        email: "",
        address: ""
      }
    }
  },
  mounted() {
    common.assureLogin(this);
    this.axios.post(common.apiBase + common.apiService.getPatient, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      this.data = res.data.data;
    }).catch((err) => {
      console.log(err);
    });
    this.axios.post(common.apiBase + common.apiService.getVaccinated, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      for (let i of res.data.data) {
        this.items.push({
          "疫苗全称": i['name'],
          "次数": i['dose'],
          "时效": i['effective_time'],
          "接种日期": i['date'],
          "接种医院": i['hospital']
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>

#content {
  padding-left: 2%;
  padding-top: 3vh;
}

#title {
  font-weight: bold;
}

#infos {
  margin-top: 30px;
  font-size: small;
}

#infos p {
  display: inline-block;
  margin-right: 40px;
  line-height: 10px;
}

#circle {
  position: relative;
  width: 50vh;
  height: 50vh;
  border-radius: 25vh;
  border: lightseagreen solid 1px;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 3vh;
  margin-bottom: 3vh;
  overflow: hidden;
}

.y1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 50vh;
  height: 50vh;
  border-radius: 25vh;
  overflow: hidden;
}

.y2 {
  position: absolute;
  left: 5vh;
  top: 5vh;
  width: 40vh;
  height: 40vh;
  border-radius: 20vh;
  overflow: hidden;
}

.y3 {
  position: absolute;
  left: 10vh;
  top: 10vh;
  width: 30vh;
  height: 30vh;
  border-radius: 15vh;
  overflow: hidden;
}

.yc {
  position: absolute;
  left: 15vh;
  top: 15vh;
  width: 20vh;
  height: 20vh;
  border-radius: 10vh;
  background-color: white;
  overflow: hidden;
  text-align: center;
  line-height: 19vh;
  font-size: 3vh;
  color: grey;
}

.area {
  display: flex;
  height: 50%;
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.y1 .area-item {
  flex: 1;
  height: 25vh;
  overflow: hidden;
  position: relative;
}

.y2 .area-item {
  flex: 1;
  height: 20vh;
  overflow: hidden;
  position: relative;
}

.y3 .area-item {
  flex: 1;
  height: 15vh;
  overflow: hidden;
  position: relative;
}

.part {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: opacity ease 0.2s;
}

.part:hover {
  opacity: 0.5;
  transition: opacity ease 0.2s;
}

.area-1 .part {
  transform-origin: left bottom;
}

.area-2 .part {
  transform-origin: left top;
}

.area-3 .part {
  transform-origin: right top;
}

.area-4 .part {
  transform-origin: right bottom;
}

#times {
  font-size: 2vh;
  color: lightgray;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 65%;
  margin-bottom: 30px;
}

</style>